import { useMutation, useQueryClient } from "@tanstack/react-query";

import { petsQueryKey } from "@/hooks/queries/useGetPets";
import { petTransactionsQueryKey } from "@/hooks/queries/useGetPetTransactions";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Pet, PurchasePetRequest } from "@/types";

// Spends coins server-side: the balance check, ledger entry and unlock land
// atomically in guac, so a double-click or a stale tab can never overdraw.
export const usePurchasePetItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      userId,
      ...purchase
    }: { userId: number } & PurchasePetRequest) => {
      const path = `pets/${userId.toString()}/purchase`;
      const res = await guacHttpClient.post<
        Pet,
        HttpResponse<Pet>,
        PurchasePetRequest
      >(path, purchase);
      return res.data;
    },
    onSuccess: (updatedPet) => {
      queryClient.setQueryData<Pet[]>(petsQueryKey, (pets) =>
        pets?.map((pet) =>
          pet.userId === updatedPet.userId ? updatedPet : pet,
        ),
      );
      // The spend added a PURCHASE ledger row server-side.
      void queryClient.invalidateQueries({
        queryKey: petTransactionsQueryKey(updatedPet.userId),
      });
    },
  });
};
